import { ApiValidationErrors } from "store/types";

type InitialValues = {
  [key: string]: any;
};

type ResultErrors = {
  [key: string]: string;
};

export default (
  initialValues: InitialValues,
  apiErrors: ApiValidationErrors
): ResultErrors => {
  const keysOfApiErrors = Object.keys(apiErrors);
  const keysOfValues = Object.keys(initialValues);

  const result: ResultErrors = {};

  keysOfApiErrors.forEach((error: string) => {
    if (keysOfValues.includes(error)) {
      result[error] = apiErrors[error][0];
    }
  });

  return result;
};
